// Account/AdminDeleteUserModal.tsx

import React, { useMemo } from "react";
import { Dimensions, Pressable, StyleSheet } from "react-native";
import { View, Text, Button, HStack, VStack } from "native-base";
import Animated, { FadeIn, FadeOut } from "react-native-reanimated";
import { Portal } from "react-native-paper";
import { useAppContext } from "../../../../../Universal/API/Context-API/AppContext";
import { webFont } from "../../../../../Universal/API/API";
import { DeanteUser } from "./interfaces";

interface Props {
  isOpen: boolean;
  user: DeanteUser | null;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const { height: SCREEN_HEIGHT } = Dimensions.get("window");

const AdminDeleteUserModal: React.FC<Props> = ({
  isOpen,
  user,
  loading,
  onCancel,
  onConfirm,
}) => {
  const { scaleAll } = useAppContext();

  const styles = useMemo(() => createStyles(scaleAll), [scaleAll]);

  if (!isOpen || !user) return null;

  return (
    <Portal>
      <View style={{ height: SCREEN_HEIGHT, width: "100%" }}>
        <Animated.View
          entering={FadeIn.duration(200)}
          exiting={FadeOut.duration(200)}
          style={[StyleSheet.absoluteFill, styles.backdrop]}
        >
          {/* outside click */}
          {!loading && (
            <Pressable style={StyleSheet.absoluteFill} onPress={onCancel} />
          )}

          {/* centered modal */}
          <View style={styles.centerWrapper} pointerEvents="box-none">
            <View style={styles.modalCard}>
              <VStack space={4}>

                <Text style={styles.title}>Удаление пользователя</Text>

                <Text style={styles.bodyText}>
                  Удалить пользователя{" "}
                  <Text style={styles.loginText}>
                    {user.login}
                  </Text>
                  ?
                </Text>

                <HStack justifyContent="flex-end" space={3} mt={2}>
                  <Button
                    variant="ghost"
                    onPress={loading ? undefined : onCancel}
                    isDisabled={loading}
                  >
                    Отмена
                  </Button>

                  <Button
                    colorScheme="red"
                    isLoading={loading}
                    onPress={onConfirm}
                  >
                    Удалить
                  </Button>
                </HStack>

              </VStack>
            </View>
          </View>
        </Animated.View>
      </View>
    </Portal>
  );
};

const createStyles = (scaleAll: number) =>
  StyleSheet.create({
    backdrop: {
      backgroundColor: "rgba(0,0,0,0.75)",
      zIndex: 9999,
    },
    centerWrapper: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
      paddingHorizontal: 16 * scaleAll,
    },
    modalCard: {
      width: "100%",
      maxWidth: 380,
      backgroundColor: "white",
      borderRadius: 12 * scaleAll,
      paddingHorizontal: 16 * scaleAll,
      paddingVertical: 18 * scaleAll,
    },
    title: {
      fontFamily: webFont("Inter"),
      fontSize: 18 * scaleAll,
      fontWeight: "600",
      color: "#111827",
    },
    bodyText: {
      fontFamily: webFont("Inter"),
      fontSize: 14 * scaleAll,
      color: "#4B5563",
    },
    loginText: {
      fontFamily: webFont("Inter"),
      fontWeight: "600",
      color: "#111827",
    },
  });

export default AdminDeleteUserModal;
